import { IUsuario } from "../interfaces/IUsuario";

export default class StorageUtils {
    // async function getItem(item){
    //     return localStorage.getItem(item)
    // }

    // async function setItem(item){
    //     return localStorage.getItem(item)
    // }

    static async clearStorage(){
        sessionStorage.clear();
    }

    static async getUsuario(): Promise<IUsuario | undefined> {
        const userJson = sessionStorage.getItem("usuario");

        if (userJson === null) {
            return;
        }

        const user = JSON.parse(userJson);

        return user;
    }

    static setUsuario(usuario: IUsuario): void {
        sessionStorage.setItem("usuario", JSON.stringify(usuario));
    }

    static async getToken(): Promise<string | null> {
        const token = sessionStorage.getItem("token");

        if (token === null) {
            return null;
        }

        return token;
    }

    static setToken(token: string): void {
        sessionStorage.setItem("token", token);
    }
}